<template>
  <div class="search-box">
    <el-form ref="form" :inline="true" :model="ruleForm" class="demo-form-inline">
      <el-form ref="form" :inline="true" :model="ruleForm" class="demo-form-inline" size="mini" >
        <el-form-item label="日志时间:">
          <date-time-range @changeDateTime="changeDateTime"/>
        </el-form-item>
        <el-form-item label="机构：">
          <dep-code-tree @change="handleChange"></dep-code-tree>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="submit">查询</el-button>
        </el-form-item>
      </el-form>
    </el-form>
  </div>
</template>
<script>
import dateTimeRange from '../comm/dateTimeRange';
import depCodeTree from '@/views/comm/depCodeTree';

export default {
  name: 'search',
  components: {
    dateTimeRange,
    depCodeTree
  },
  data() {
    return {
      ruleForm: {
        startDate: '',
        endDate: '',
        depCode: ''
      }
    };
  },
  methods: {
    changeDateTime(date) {
      Object.assign(this.ruleForm, this.ruleForm, date);
    },
    handleChange(arry) {
      if (arry.length > 0) {
        this.ruleForm.depCode = arry[arry.length - 1];
      }
      else {
        this.ruleForm.depCode = '';
      }
    },
    submit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.$emit('getLogAnalysis', this.ruleForm);// emit
        }
        else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
